import {getRCForLimitType} from "../../utils";
import * as React from "react";
import {useState} from "react";
import {ContactInput, ManageContactsForm} from "../../types/clients";

export default function ContactsForm(props: {
  manageContactsForm: ManageContactsForm,
  addContactClicked: (value: string) => boolean
  removeContactClicked: (value: string) => void
}) {
  const [emailAddress, setEmailAddress] = useState<string>('');

  const addContact = () => {
      const result = props.addContactClicked(emailAddress)

      if(result) {
        setEmailAddress('');
      }
  }

  const handleEmailAddressInputKeyDown: (
    event: React.KeyboardEvent<HTMLInputElement>,
  ) => void = (event): void => {
    if (event.key === 'Enter') {
      addContact();
    }
  }

  return <div>
    <div className='sticky-below-header'>
      <h2 className='no-margin-top'>
        {`${getRCForLimitType(
          props.manageContactsForm.associatedAlertForm
            .limitType,
        )} ${
          props.manageContactsForm.severity
        } Recipients`}
      </h2>
      <div className='manage-contacts-grid'>
        <div
          className='add-contacts-form-selector manage-contacts-grid'
        >
          <input
            value={emailAddress}
            placeholder='Email Address'
            onChange={(event) => setEmailAddress(event.currentTarget.value)}
            className='inline-block input no-margin-bottom'
            required={true}
            type='email'
            multiple={true}
            onKeyDown={handleEmailAddressInputKeyDown}
          />
          <button className='button no-margin-top' type="button" onClick={addContact}>Add Contact
          </button>
        </div>
        {
          [...props.manageContactsForm.associatedAlertForm
            .contacts].map(c =>
            contactsToEmailInputs(c, props.removeContactClicked),
          )}
      </div>
    </div>
  </div>

  function contactsToEmailInputs(contact: ContactInput, removeContactClicked: (value: string) => void): JSX.Element {
    return <React.Fragment key={contact.emailAddress}>
      <label>{contact.emailAddress}</label>{' '}
      <button
        className='button'
        value={contact.id.toString()}
        onClick={(event) => removeContactClicked(event.currentTarget.value)}
      >
        Remove Contact
      </button>
    </React.Fragment>
  }
}
